import './App.css'
import whatsapp_icon from './images/whatsapp.svg';

function Whatsapp() {
    return (
        <>
            <div class="whatsappFloat">
                <a href="https://wa.me/5213335709193" target="_blank" rel="noreferrer"><img src={whatsapp_icon} width="36" /></a>
            </div>
        </>
    );
}

export default Whatsapp;